import { TOPCON_BORDER_RADIUS, TOPCON_BOX_SHADOW, TOPCON_COLORS, TOPCON_FONTS, TOPCON_SPACING, } from '../topconThemeConf';
export const topconNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: TOPCON_BORDER_RADIUS.default,
            boxShadow: TOPCON_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: TOPCON_COLORS.primary.main,
        },
        info: {
            backgroundColor: TOPCON_COLORS.brand.main,
        },
        error: {
            backgroundColor: TOPCON_COLORS.error.main,
        },
        warning: {
            backgroundColor: TOPCON_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: TOPCON_COLORS.font.light,
            fontSize: TOPCON_FONTS.size.mediumBig,
            fontWeight: TOPCON_FONTS.weight.bold,
            height: TOPCON_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: TOPCON_FONTS.size.medium,
            fontWeight: TOPCON_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: TOPCON_COLORS.font.light,
            marginTop: TOPCON_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=topconNotificationsStyle.js.map